module.exports = __webpack_public_path__ + "img/houduan.cfe7d070.jpg";